import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { IconButton, TableCell, TableRow, Tooltip } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { DeleteButtonWithModal } from "frontend/src/ui/delete-button-with-modal";
import { paths } from "frontend/src/pages/paths/index";
import { useDeleteProgram } from "frontend/src/domain/programs/actions";
export var Program = function (_a) {
    var title = _a.title, id = _a.id;
    var run = useDeleteProgram().run;
    var remove = function () { return run(id); };
    return (React.createElement(TableRow, null,
        React.createElement(TableCell, null, title),
        React.createElement(TableCell, null, "TODO"),
        React.createElement(TableCell, null,
            React.createElement(Tooltip, { title: "Редактировать" },
                React.createElement(RouterLink, { to: paths.business.owner.programs.edit(id) },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(Edit, null))))),
        React.createElement(TableCell, null,
            React.createElement(DeleteButtonWithModal, { onDelete: remove, message: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \"".concat(title, "\"?") }))));
};
